module.exports = __webpack_public_path__ + "img/dot2.632afff5.png";